import Avatar from "@mui/material/Avatar";

const UserAvatar = ({ user, ...props }) => {
  return <Avatar src={user?.avatar} alt={user.fullname} {...props} />;
};

export default UserAvatar;
